var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ol",
    { staticClass: "breadcrumb" },
    _vm._l(_vm.breadcrumbs, function(folder) {
      return _c(
        "li",
        {
          key: folder.id,
          staticClass: "breadcrumb-item",
          class: { active: folder === _vm.baseFolder },
          on: {
            click: function($event) {
              return _vm.$emit("folder-selected", folder)
            }
          }
        },
        [_vm._v("\n        " + _vm._s(folder.name) + "\n    ")]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }